import { render, staticRenderFns } from "./RefundWaitForProcess.vue?vue&type=template&id=54db10c0&scoped=true&"
import script from "./RefundWaitForProcess.vue?vue&type=script&lang=js&"
export * from "./RefundWaitForProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54db10c0",
  null
  
)

export default component.exports